// import React, { useState, useEffect } from 'react';
// import { Modal } from 'bootstrap';
// import { allServices } from "../components/servicesData"; 


// const PopUpForm = ({ showOnLoad = false }) => {
//   const servicesOptions = allServices.map(service => ({
//     value: service.slug,
//     label: service.name.length > 60 
//       ? `${service.name.substring(0, 60)}...` 
//       : service.name
//   }));
//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     phone: '',
//     service: '',
//     message: ''
//   });

//   useEffect(() => {
//     if (showOnLoad) {
//       const modalElement = document.getElementById('exampleModal');
//       if (modalElement) {
//         const modalInstance = new Modal(modalElement);
//         modalInstance.show();
//       }
//     }
//   }, [showOnLoad]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     console.log('Form submitted:', formData);
//     // TODO: Submit to backend
//   };

//   return (
//     <div className="modal fade" id="exampleModal" tabIndex="-1" aria-hidden="true">
//       <div className="modal-dialog modal-lg">
//         <div className="modal-content">
//           <div className="modal-header border-0 pb-0">
//             {/* <h1 className="text-lg text-center font-semibold text-black uppercase px-3 py-2 bg-green-500">Get Compliance for Your Product in India</h1> */}
//             <h1 className="text-xl text-center font-bold text-green-500 w-100" >Get Compliance for Your Product in India</h1>
//             <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
//           </div>
//           <div className="modal-body">
//             <div className="d-flex flex-wrap">
//               <div className="col-lg-6 p-2">
//                 <img
//                   className="img-fluid"
//                   src="https://www.elitasrcs.com/frontend/assets/images/BIS-Certification-Consultant.jpg"
//                   alt="BIS Certification Services in India"
//                 />
//               </div>
//               <div className="col-lg-6 p-2">
//                 <form onSubmit={handleSubmit}>
//                   <div className="mb-3">
//                     <input
//                       type="text"
//                       name="name"
//                       placeholder="Enter your name"
//                       className="form-control"
//                       value={formData.name}
//                       onChange={handleChange}
//                       required
//                     />
//                   </div>
//                   <div className="mb-3">
//                     <input
//                       type="email"
//                       name="email"
//                       placeholder="Enter your email"
//                       className="form-control"
//                       value={formData.email}
//                       onChange={handleChange}
//                       required
//                     />
//                   </div>
//                   <div className="mb-3">
//                     <input
//                       type="tel"
//                       name="phone"
//                       placeholder="Enter your mobile"
//                       className="form-control"
//                       value={formData.phone}
//                       onChange={handleChange}
//                       required
//                     />
//                   </div>
//                   <div className="mb-3">
//                   <select
//                     name="service"
//                     className="form-select"
//                     value={formData.service}
//                     onChange={handleChange}
//                     required
//                   >
//                     <option value="">--Select Service--</option>
//                     {servicesOptions.map((service) => (
//                       <option key={service.value} value={service.value}>
//                         {service.label}
//                       </option>
//                     ))}
//                   </select>
                  
//                 </div>
//                   <div className="mb-3">
//                     <textarea
//                       name="message"
//                       placeholder="Message here..."
//                       className="form-control"
//                       rows={4}
//                       value={formData.message}
//                       onChange={handleChange}
//                     ></textarea>
//                   </div>
//                   <button
//                     className="w-full py-2 bg-green-500 text-white rounded hover:bg-green-600 transition duration-200"
//                     type="submit"
//                   >
//                     Request A Quote
//                   </button>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default PopUpForm;

import React, { useState, useEffect } from 'react';
import { Modal } from 'bootstrap';
import { allServices } from "../components/servicesData";
import axios from 'axios';
import Swal from 'sweetalert2';
import ReCAPTCHA from "react-google-recaptcha";
import apiCongfig from '../api/apiCongfig';

const PopUpForm = ({ showOnLoad = false }) => {
  const servicesOptions = allServices.map(service => ({
    value: service.slug,
    label: service.name.length > 60 
      ? `${service.name.substring(0, 60)}...` 
      : service.name
  }));
  
  // Add "Others" option
  servicesOptions.push({ value: "OTHERS", label: "Others" });

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [recaptchaToken, setRecaptchaToken] = useState(null);
  const [recaptchaError, setRecaptchaError] = useState("");

  useEffect(() => {
  if (showOnLoad) {
    const modalElement = document.getElementById('popupFormModal');
    if (modalElement) {
      const modalInstance = new Modal(modalElement);
      modalInstance.show();
    }
  }
}, [showOnLoad]); // 🔁 watch showOnLoad


  const validate = () => {
    const newErrors = {};
    let isValid = true;

    if (!formData.name.trim() || formData.name.trim().length < 3) {
      newErrors.name = "Name must be at least 3 characters long.";
      isValid = false;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formData.email || !emailRegex.test(formData.email)) {
      newErrors.email = "Enter a valid email address.";
      isValid = false;
    }

    const phoneRegex = /^[6-9]\d{9}$/;
    if (!formData.phone || !phoneRegex.test(formData.phone)) {
      newErrors.phone = "Enter a valid 10-digit phone number starting with 6-9.";
      isValid = false;
    }

    if (!formData.service) {
      newErrors.service = "Please select a service.";
      isValid = false;
    }

    if (!recaptchaToken) {
      setRecaptchaError("Please verify that you're not a robot.");
      isValid = false;
    } else {
      setRecaptchaError("");
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const handleRecaptchaChange = (token) => {
    setRecaptchaToken(token);
    if (recaptchaError) setRecaptchaError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    setLoading(true);

    const selectedService = servicesOptions.find(
      (s) => s.value === formData.service
    );

    const payload = {
      ...formData,
      service: selectedService?.label || formData.service,
      recaptchaToken,
    };

    try {
      const response = await apiCongfig.post("/contact", payload);
      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'success',
        title: 'Your request has been sent!',
        text: 'We will contact you shortly.',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
      });

      // Reset form
      setFormData({
        name: '',
        email: '',
        phone: '',
        service: '',
        message: ''
      });
      setRecaptchaToken(null);
      setErrors({});
      if (window.grecaptcha) window.grecaptcha.reset();

      // Close modal after successful submission
      const modalElement = document.getElementById('popupFormModal');
      if (modalElement) {
        const modalInstance = Modal.getInstance(modalElement);
        modalInstance.hide();
      }
    } catch (err) {
      console.error('Submission error:', err);
      if (err.response?.data?.fields) {
        setErrors(err.response.data.fields);
        Swal.fire({
          toast: true,
          position: 'top-end',
          icon: 'error',
          title: 'Please fix the highlighted fields',
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
      } else {
        Swal.fire({
          title: 'Error!',
          text: err.response?.data?.error || 'Failed to send your request. Please try again.',
          icon: 'error',
          confirmButtonText: 'OK',
        });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal fade" id="popupFormModal" tabIndex="-1" aria-hidden="true">
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header border-0 pb-0">
            <h1 className="text-xl text-center font-bold text-green-500 w-100">
              Get Compliance for Your Product in India
            </h1>
            <button 
              type="button" 
              className="btn-close" 
              data-bs-dismiss="modal" 
              aria-label="Close"
              disabled={loading}
            ></button>
          </div>
          <div className="modal-body">
            <div className="d-flex flex-wrap">
              <div className="col-lg-6 p-2">
                <img
                  className="img-fluid rounded"
                  src="https://www.elitasrcs.com/frontend/assets/images/BIS-Certification-Consultant.jpg"
                  alt="BIS Certification Services in India"
                />
              </div>
              <div className="col-lg-6 p-2">
                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <input
                      type="text"
                      name="name"
                      placeholder="Enter your name"
                      className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                      value={formData.name}
                      onChange={handleChange}
                    />
                    {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                  </div>
                  <div className="mb-3">
                    <input
                      type="email"
                      name="email"
                      placeholder="Enter your email"
                      className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                      value={formData.email}
                      onChange={handleChange}
                    />
                    {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                  </div>
                  <div className="mb-3">
                    <input
                      type="tel"
                      name="phone"
                      placeholder="Enter your mobile"
                      className={`form-control ${errors.phone ? 'is-invalid' : ''}`}
                      value={formData.phone}
                      onChange={handleChange}
                    />
                    {errors.phone && <div className="invalid-feedback">{errors.phone}</div>}
                  </div>
                  <div className="mb-3">
                    <select
                      name="service"
                      className={`form-select ${errors.service ? 'is-invalid' : ''}`}
                      value={formData.service}
                      onChange={handleChange}
                    >
                      <option value="">--Select Service--</option>
                      {servicesOptions.map((service) => (
                        <option key={service.value} value={service.value}>
                          {service.label}
                        </option>
                      ))}
                    </select>
                    {errors.service && <div className="invalid-feedback">{errors.service}</div>}
                  </div>
                  <div className="mb-3">
                    <textarea
                      name="message"
                      placeholder="Message here..."
                      className="form-control"
                      rows={4}
                      value={formData.message}
                      onChange={handleChange}
                    ></textarea>
                  </div>
                  <div className="mb-3">
                    <ReCAPTCHA
                      sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                      onChange={handleRecaptchaChange}
                      onErrored={() => setRecaptchaError("reCAPTCHA failed to load. Please disable any ad blockers.")}
                      onExpired={() => setRecaptchaError("reCAPTCHA expired. Please try again.")}
                    />
                    {recaptchaError && <div className="text-danger small mt-1">{recaptchaError}</div>}
                  </div>
                  <button
                    className="w-100 py-2 bg-green-500 text-white rounded hover:bg-green-600 transition duration-200"
                    type="submit"
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Sending...
                      </>
                    ) : (
                      'Request A Quote'
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopUpForm;